<template>
  <div class="app-container">
    <!-- 综合查询 -->
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
             <el-form-item label="捆包编号" >
              <el-input  placeholder="可支持多个" type="textarea" v-model="searchFrom.cargoBarcode" ></el-input>
            </el-form-item>
            <el-form-item label="计划时间:"   >
                <el-date-picker
                    v-model="searchFrom.createTimes"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                   :default-time="['00:00:00', '23:59:59']"
                ></el-date-picker>
              </el-form-item>
             <el-form-item label="状态">
              <el-select v-model="searchFrom.sendCarFlag" size="mini" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option label="未处理" value="0"></el-option>
                <el-option label="已配车" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="实绩车号">
              <el-input size="mini" v-model.trim="searchFrom.plateNumber" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="首钢计划号">
              <el-input size="mini" v-model.trim="searchFrom.billOfLadingNo" placeholder=""></el-input>
            </el-form-item>
             <el-form-item label="订单编号">
              <el-input size="mini" v-model.trim="searchFrom.orderNo" placeholder=""></el-input>
            </el-form-item>
             <el-form-item label="品名">
              <el-input size="mini" v-model.trim="searchFrom.productName" placeholder=""></el-input>
            </el-form-item>
        </div>
        <div style="margin:5px 0 5px">
          <el-form-item>
            <el-button type="primary" @click="chaxun"  v-if="btnFlg[0]" size="mini" >查询</el-button>
            <el-button type="primary" @click="chongzhi" size="mini">重置</el-button>
            <!-- <el-button type="primary" size="mini"  v-if="btnFlg[1]" @click="daochu" >导出</el-button> -->
            <el-button type="primary" size="mini"  v-if="btnFlg[2]" @click="sfdzFn" >收发地址</el-button>
            <el-button type="primary" size="mini"  v-if="btnFlg[3]" @click="peicheFn" >分配车辆</el-button>
            <!-- <el-button type="primary" size="mini"  v-if="btnFlg[4]" @click="huancheFn" >换车</el-button>
            <el-button type="primary" size="mini"  v-if="btnFlg[5]" @click="quxiaoFn" >取消配车</el-button> -->
            <el-button type="primary" size="mini"  v-if="btnFlg[6]" @click="shouruFn" >收入结算</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--表格-->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" ref="table" highlight-current-row :data="tableData" @row-click="dianjixuanzhong" bordersize="mini" @selection-change='selectGoods' style="width: 100%" center border>
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column label="操作"  width="100">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini"   @click="wayFn(scope.row)">运单</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="orderNo" label="订单号" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="billOfLadingNo" label="首钢计划号" align="center" width="160"></el-table-column>
        <el-table-column prop="temporaryFlg" width="100" :show-overflow-tooltip="true" :formatter="emptyFn" label="状态">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.sendCarFlag == '0'"  style="color:rgb(242, 5, 5)">未处理</div>
              <div  v-if="scope.row.sendCarFlag == '1'" style="color:rgb(27, 142, 8)">已配车</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="outStockName" label="起始站点" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="inStockName" label="卸点" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payee" label="结算客户" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sellerName" label="供货方名称" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="preCarNum" label="预车号" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="实绩车号" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center" width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="startDirection" label="始发流向" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="endDirection" label="目的流向" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="delivyRemark" label="车船直取标志" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="measuringUnit" label="计量单位" align="center" width="80"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="orderNumber" label="总件数" align="center" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createTime" label="计划时间" align="center" width="170"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="arrivalTime" label="要求送达时间" align="center" width="120"></el-table-column>
         <el-table-column :show-overflow-tooltip="true" prop="deliverAddress" label="发货地址" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="deliverPerson" label="发货人" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="deliverPhone" label="发货电话" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receivingAddress" label="收货地址" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receivingPerson" label="收货人" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receivingPhone" label="收货电话" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="" label="送达时间" align="center" width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sendUser" label="配车人" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="sendDate" label="配车时间" align="center" width="170"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="incomePatternName" label="收入方式" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="makeTicketYn" label="是否开票" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="ticketSystemYn" label="是否一票制" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="revenueValuationName" label="收入计价" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="incomeUnitPrice" label="收入单价" :formatter="formatterRowEmpty" align="center" width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="incomeAmount" label="收入金额" align="center" width="100"></el-table-column>
      </el-table>
      <!--分页-->
      <div class="pags" style="text-align: left">
        <el-pagination background @current-change="handleCurrentChangeA" :current-page="current" :page-size="pagesize" :page-sizes="[50,100,200,500]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeA" :total="total"></el-pagination>
      </div>
    </div>
    <!--详情表格-->
    <div class="market_out" style="margin-top:40px">
      <div class="detailsTitle">
        <h4>货物明细</h4>
      </div>
      <div class="ruKuZuoyeWarp-body-detailsTab">
        <div class="ruKuZuoyeWarp-body-table" :style="{ height: XQh }">
          <el-table height="100%" size="mini" ref="tabref" :data="xiangqingTableData" style="width: 100%" :header-cell-style="{
                        background: '#F5F5F5',
                        color: 'black',
                      }">
            <el-table-column type="index" align="center" fixed label="序号" width="60"></el-table-column>
            <el-table-column prop="cargoBarcode" min-width="160" label="捆包号"></el-table-column>
            <el-table-column prop="customerName" min-width="160" label="货主"></el-table-column>
            <el-table-column prop="productName"  min-width="120" label="品名"></el-table-column>
             <el-table-column prop="specification"  min-width="120" label="规格"></el-table-column>
            <!-- <el-table-column prop="flowTo" min-width="160" label="牌号"></el-table-column>
            <el-table-column prop="flowUnloadName" min-width="360" label="产地"></el-table-column> -->
            <el-table-column prop="number"  min-width="120" label="件数"></el-table-column>
            <el-table-column prop="weight"  min-width="120" label="重量（吨）"></el-table-column>
            <el-table-column prop="contractNumber"  min-width="120" label="合同号"></el-table-column>
            <el-table-column prop="agreementNumber" width="120" label="合约号"></el-table-column>
            <el-table-column prop="receivUnit"  min-width="120" label="是否覆盖雨布">
              <template scope="scope">
                <span v-if="scope.row.rainCoatFlag == 'Y'">是</span>
                <span v-else>否</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
     <!-- 配车 -->
    <el-dialog  :title="title" :close-on-click-modal="false" :close-on-press-escape="false"  @close="peicheFlag = false"  :visible.sync="peicheFlag" width="900px" center>
      <div>
        <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline" label-width="90px" size="mini">
          <peiche :goodform="goodform" v-if="peicheFlag"></peiche>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="peicheFlag = false">取 消</el-button>
        <el-button type="primary" @click="PCsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 收发地址 -->
    <el-dialog  title="收发地址" :close-on-click-modal="false" :close-on-press-escape="false"  @close="dizhiFlag = false"  :visible.sync="dizhiFlag" width="1000px" center>
      <div>
        <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform"   class="demo-form-inline jiaoyan" label-width="90px" size="mini">
          <!-- 地址组件 -->
          <addDizhi :goodform="goodform" ></addDizhi>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dizhiFlag = false">取 消</el-button>
        <el-button type="primary" @click="DZsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 收入结算 -->
    <el-dialog  title="收入结算" :close-on-click-modal="false" :close-on-press-escape="false"  @close="shouruFlag = false"  :visible.sync="shouruFlag" width="1000px" center>
      <div>
        <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
          <shouru :goodform="goodform"></shouru>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shouruFlag = false">取 消</el-button>
        <el-button type="primary" @click="SRsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { emptyFn, dateTimeFormat, formatterRowEmpty } from '@/utils/util'
import { find3PLOrderList, update3PLDeliverReceiving, find3PLOrderGoodsList, sendCar, updateSendCar, deleteSendCar, update3PLIncome } from '@/api/newTMS'
import peiche from '@/views/newTMS/transportation/shouGangJH/peiche.vue'
import addDizhi from '@/views/newTMS/transportation/shouGangJH/addDizhi.vue'
import shouru from '@/views/newTMS/transportation/shouGangJH/shouru.vue'
export default {
  components: {
    peiche, addDizhi, shouru
  },
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      xiangqingTableData: [],
      searchFrom: { },
      daochuDis: false,
      h: '500px',
      XQh: '200px',
      tableData: [],
      pagesize: 50,
      current: 1,
      total: 0,
      pagesizeXQ: 20,
      currentXQ: 1,
      totalXQ: 0,
      peicheFlag: false,
      dizhiFlag: false,
      shouruFlag: false,
      goodform: {},
      rules: {
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ]
      },
      isAdd: true,
      btnFlg: [],
      btnIdArr: ['01N01E0100', '01N01E0200', '01N01E0300', '01N01E0400', '01N01E0500', '01N01E0600', '01N01E0700', '01N01E0800']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/shouGangJH')
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = 0.6 * pH - h - 80 + 'px'
    this.XQh = 0.4 * pH - 145 + 'px'
  },

  methods: {
    // 运单
    wayFn (row) {
      this.$router.push({ name: 'qiYunWay', query: { orderNo: row.orderNo } })
    },
    // 取消配车
    quxiaoFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].sendCarFlag == '0') {
        this.$alert('只有已配载的数据可以取消配车', '系统提示')
        return
      }
      this.$confirm('是否取消配车', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteSendCar({ orderIdList: [selectData[0].orderId] }).then(res => {
          loading.close()
          this.$message({
            message: '成功',
            type: 'success'
          })
          this.getList()
        })
          .catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
      }).catch(() => { })
    },
    // 收入结算
    shouruFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.goodform = {
        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '否',
        revenueValuation: '0'
      }
      this.goodform.measuringUnit = selectData[0].measuringUnit
      this.goodform.orderBusinessIdList = selectData.map(itme => itme.orderBusinessId)
      this.shouruFlag = true
    },
    SRsaveFn () {
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          update3PLIncome(this.goodform).then(res => {
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            loading.close()
            this.shouruFlag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 收发地址
    sfdzFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      this.goodform = {}
      this.goodform.orderBusinessIdList = selectData.map(itme => itme.orderBusinessId)
      this.dizhiFlag = true
    },
    DZsaveFn () {
      if (!this.goodform.deliverAddressId) {
        this.$alert('请选择发货地址', '系统提示')
        return
      }
      if (!this.goodform.receivingAddressId) {
        this.$alert('请选择收货地址', '系统提示')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      update3PLDeliverReceiving(this.goodform).then(res => {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        loading.close()
        this.dizhiFlag = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    huancheFn () {
      let selectData = this.$refs.table.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let flag = selectData.every(item => item.sendCarFlag == '1')
      let flag1 = selectData.every(item => item.payee)
      if (!flag) {
        this.$alert('只能选择已配载的计划！', '系统提示')
        return
      }

      this.title = '换车'
      this.isAdd = false
      this.goodform = {}
      this.goodform.orderIdList = selectData.map(itme => itme.orderId)
      this.peicheFlag = true
      this.goodform = {}
      this.goodform.orderIdList = selectData.map(itme => itme.orderId)
      this.peicheFlag = true
    },
    // 配车
    peicheFn () {
      let selectData = this.$refs.table.selection
      let flag = selectData.every(item => item.sendCarFlag == '0')
      let flag1 = selectData.every(item => item.receivingAddressId)
      let flag2 = selectData.every(item => item.deliverAddressId)
      let flag3 = selectData.every(item => item.payee)
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      if (!flag) {
        this.$alert('只能选择未处理的计划！', '系统提示')
        return
      }
      if (!flag1) {
        this.$alert('只能选择收货地址有值的计划！', '系统提示')
        return
      }
      if (!flag2) {
        this.$alert('只能选择发货地址有值的计划', '系统提示')
        return
      }
      // if (!flag3) {
      //   this.$alert('只能选择已维护结算客户的计划！', '系统提示')
      //   return
      // }
      this.title = '分配车辆'
      this.isAdd = true
      this.goodform = {}
      this.goodform.orderIdList = selectData.map(itme => itme.orderId)
      this.peicheFlag = true
    },
    PCsaveFn () {
      if (!this.goodform.driverId) {
        this.$alert('请选择司机', '系统提示')
        return false
      }
      if (!this.goodform.plateNumber) {
        this.$alert('请选择车辆', '系统提示')
        return false
      }

      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.isAdd) {
            sendCar(this.goodform).then(res => {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              loading.close()
              this.peicheFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            updateSendCar(this.goodform).then(res => {
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              loading.close()
              this.peicheFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    // 导出
    daochu () {
      exportExcel(
        this.global.tms + '/comQuery/exportComQueryList',
        this.searchFrom,
        '首钢计划'
      )
    },
    // 主数据
    getList () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      if (this.searchFrom.createTimes) {
        this.searchFrom.createTimeStart = this.searchFrom.createTimes[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTimes[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      if (this.searchFrom.cargoBarcode) {
        this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.replace(/\n/g, ',')
      } else {
        this.searchFrom.cargoBarcodes = ''
      }
      find3PLOrderList({
        pageNo: this.current, // 页数
        pageSize: this.pagesize, // 条数
        ...this.searchFrom
      })
        .then((res) => {
          this.total = res.total
          this.tableData = res.list
          if (this.tableData[0]) {
            setTimeout(() => {
              // this.$refs.table.toggleRowSelection(this.$refs.table.data[0])
              this.$refs.table.setCurrentRow(this.$refs.table.data[0])
              find3PLOrderGoodsList({
                orderId: this.$refs.table.data[0].orderId
              })
                .then((res) => {
                  this.xiangqingTableData = res
                })
                .catch((err) => {
                  DonMessage.error(err.message)
                })
            }, 10)
          } else {
            this.xiangqingTableData = []
          }

          loading.close()
        })
        .catch((err) => {
          DonMessage.error(err.message)
          loading.close()
        })
    },
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = row
      this.$refs.table.toggleRowSelection(row)
      find3PLOrderGoodsList({
        orderId: row.orderId
      })
        .then((res) => {
          this.xiangqingTableData = res
        })
        .catch((err) => {
          DonMessage.error(err.message)
        })
    },
    // 选择数据
    selectGoods (selection) {

    },
    peihuoRow (row, column, event) {
      this.$refs.peihuoTable.toggleRowSelection(row)
    },
    selectPeihuo (selection) {
      this.selectListPH = selection
    },
    xiangqing (row) {
      this.title = '详情'
      this.change(row)
    },
    fatherMethod () {
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongzhi () {
      this.searchFrom = {}
      this.pagesize = 50
      this.current = 1
      // this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.getList()
    },
    // 表格分页
    handleCurrentChangeXQ (val) {
      this.currentXQ = val
      this.getList()
    },
    handleSizeChangeXQ (val) {
      this.pagesizeXQ = val
      this.getList()
    }
  }
}
</script>

  <style lang="less" scoped>

/deep/.el-form{
  width: 100%;
}

.formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
